import React, { useState, useEffect } from "react";
import { Dialog } from "@headlessui/react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import axios from "axios";

const AppointmentModal = ({ modalOpen, setModalOpen }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
const [appointmentPurpose, setAppointmentPurpose] = useState("");
const [nearestOffice, setNearestOffice] = useState("");

  // Form fields
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");

  useEffect(() => {
    if (!selectedDate) return;

    const fetchSlots = async () => {
      try {
        const response = await axios.get(`https://charethribs.com/api/timeslots`,{
         
        });
        setAvailableSlots(response.data || []);
      } catch (error) {
        console.error("Error fetching slots:", error);
        setAvailableSlots([]);
      }
    };

    fetchSlots();
  }, [selectedDate]);

  const formatTimeToIST = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":");
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  };

 
  const handleBooking = async () => {
    if (!appointmentPurpose || !nearestOffice || !name || !email || !mobile || !selectedDate || !selectedSlot) {
      alert("Please fill in all fields.");
      return;
    }

    const payload = {
      name,
      email,
      mobile,
      date: selectedDate.toISOString().split("T")[0],
      time_slot_id: selectedSlot.id,
      time: selectedSlot.start_time,
        appointment_purpose: appointmentPurpose,
      nearest_office: nearestOffice,
    };

    try {
      const response = await axios.post("https://charethribs.com/api/booking", payload);
      alert("Appointment booked successfully!");
      setModalOpen(false);
      setName("");
      setEmail("");
      setMobile("");
      setSelectedDate(null);
      setSelectedSlot(null);
      setAppointmentPurpose("");
      setNearestOffice("")
    } catch (error) {
      console.error("Booking error:", error);
      alert("Error booking appointment. Please try again.");
    }
  };

  return (
<Dialog open={modalOpen} onClose={() => setModalOpen(false)} className="relative z-50">
  {/* Overlay */}
  <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" aria-hidden="true" />

  {/* Modal */}
  <div className="fixed inset-0 flex items-center justify-center p-4">
    <Dialog.Panel className="w-full max-w-3xl bg-white rounded-2xl p-8 shadow-2xl overflow-y-auto max-h-[90vh]">
      {/* Title */}
 <div className="flex justify-between items-center mb-8">
  <Dialog.Title className="text-3xl font-bold text-gray-800">
    Book Appointment
  </Dialog.Title>
  <button
    onClick={() => setModalOpen(false)}
    className="text-gray-500 hover:text-gray-700 transition"
    aria-label="Close"
  >
    ✕
  </button>
</div>


      {/* Grid Form */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <input
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full border px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#b7b7a1]"
        />

        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#b7b7a1]"
        />

        <input
          type="tel"
          placeholder="Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          className="w-full border px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#b7b7a1]"
        />

        <select
          value={nearestOffice}
          onChange={(e) => setNearestOffice(e.target.value)}
          className="w-full border px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#b7b7a1]"
        >
          <option value="">Select nearest office</option>
          <option value="Head Office - KORMANGALA">Head Office - KORMANGALA</option>
          <option value="Branch Office - K R Puram">Branch Office - K R Puram</option>
        </select>

        <textarea
          placeholder="Appointment Purpose"
          value={appointmentPurpose}
          onChange={(e) => setAppointmentPurpose(e.target.value)}
          rows="3"
          className="w-full border px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#b7b7a1] md:col-span-2"
        ></textarea>

        {/* Date Picker */}
        <div className="border rounded-lg p-4 md:col-span-1">
          <p className="font-medium mb-3">Select Date:</p>
          <DayPicker
            mode="single"
            selected={selectedDate}
            onSelect={(date) => {
              setSelectedDate(date);
              setSelectedSlot(null);
            }}
            fromDate={new Date()}
          />
        </div>

        {/* Time Slots */}
        <div className="border rounded-lg p-4 md:col-span-1">
          <p className="font-medium mb-3">Available Time Slots:</p>
          {availableSlots.length > 0 ? (
            <div className="flex flex-wrap gap-2">
              {availableSlots.map((slot) => (
                <button
                  key={slot.id}
                  onClick={() => setSelectedSlot(slot)}
                  className={`px-3 py-2 border rounded-lg text-sm transition ${
                    selectedSlot?.id === slot.id
                      ? "bg-[#b7b7a1] text-white"
                      : "bg-white hover:bg-gray-100"
                  }`}
                >
                  {formatTimeToIST(slot.start_time)}
                </button>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">Select a date to view available slots.</p>
          )}
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-8 flex justify-end gap-4">
        <button
          onClick={() => setModalOpen(false)}
          className="px-5 py-2 border rounded-lg text-gray-600 hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          onClick={handleBooking}
          className={`px-6 py-2 rounded-lg font-semibold transition ${
            name && email && mobile && appointmentPurpose && nearestOffice && selectedDate && selectedSlot
              ? "bg-[#b7b7a1] text-white hover:bg-[#a0a08b]"
              : "bg-gray-300 text-gray-600 cursor-not-allowed"
          }`}
          disabled={
            !name ||
            !email ||
            !mobile ||
            !appointmentPurpose ||
            !nearestOffice ||
            !selectedDate ||
            !selectedSlot
          }
        >
          Confirm
        </button>
      </div>
    </Dialog.Panel>
  </div>
</Dialog>


  );
};

export default AppointmentModal;
